import React from "react";
import "../../../assets/style/LoaderModalConfirmation.css";

import { IconAlertTriangle, IconCircleCheck, IconCircleX } from "@tabler/icons-react";

const ConfirmationModal = ({ visible, state, message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div className="modal modal-blur custom-modal fade show" tabIndex="-1" style={{ display: "block" }} role="dialog" aria-modal="true">
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          {state === "pregunta" && (
            <>
              <button type="button" className="btn-close" onClick={onCancel} aria-label="Close"></button>
              <div className="modal-status bg-warning"></div>
              <div className="modal-body text-center py-4">
                <IconAlertTriangle className="icon mb-2 text-warning icon-lg" />
                <h3>¿Está seguro de proceder?</h3>
                <div className="text-secondary">Antes de insertar los datos, por favor asegúrese de revisar todas las direcciones. Una vez cargados los datos, no podrá modificarlos.</div>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-secondary w-100" onClick={onCancel}>
                        Cancelar
                      </button>
                    </div>
                    <div className="col">
                      <button className="btn btn-warning w-100" onClick={onConfirm}>
                        Confirmar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {state === "cargando" && (
            <>
              <div className="modal-body text-center rounded">
                <div className="carga-preloader"></div>
                <h1 className="pt-3">Cargando...</h1>
              </div>
            </>
          )}
          {state === "error" && (
            <>
              <button type="button" className="btn-close" onClick={onCancel} aria-label="Close"></button>
              <div className="modal-status bg-danger"></div>
              <div className="modal-body text-center py-4">
                <IconCircleX className="icon mb-2 text-danger icon-lg" />
                <h3>{message}</h3>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-danger btn-block w-100 btn-pill" onClick={onCancel}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {state === "exito" && (
            <>
              <button type="button" className="btn-close" onClick={onCancel} aria-label="Close"></button>
              <div className="modal-status bg-success"></div>
              <div className="modal-body text-center py-4">
                <IconCircleCheck className="icon mb-2 text-success icon-lg" />
                <h3>{message}</h3>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-success btn-block w-100 btn-pill" onClick={onCancel}>
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
